import CheckingLocationPopup from 'components/popups/CheckingLocationPopup'
import { ReactComponent as Arrow } from 'assets/circleArrow.svg'
import { selectWarehouse } from '../Warehouses/warehousesSlice'
import { ReactComponent as Compass } from 'assets/compass.svg'
import useWarehouseAction from './hooks/useWarehouseAction'
import BigCircleBtn from 'components/buttons/BigCircleBtn'
import { ReactComponent as Gate } from 'assets/gate.svg'
import CircleBtn from 'components/buttons/CircleBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import { STATUS } from 'utils/constants'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import React from 'react'

interface MagActionsProps {
  id: string
  expanded: boolean
  toggleMenu: basic.BasicFunc
}

const MagActions: React.FC<MagActionsProps> = ({ id, expanded, toggleMenu }) => {
  const { doorState, gateHasOnlineAccess, placeAddress, isAlreadyOpened, inFuture, placeGps } = useReduxSelector(state => selectWarehouse(state, id))
  const { disabled, hasPermissionsToOpen, action } = useWarehouseAction(id)
  const config = useReduxSelector(selectConfig)

  const { push, replace, goBack } = useHistory()
  const { t } = useTranslation('warehouse')
  const { popup, openPopup } = usePopupState()

  return (
    <>
      {popup === 'checkingMagLocation' && <CheckingLocationPopup
        targetPosition={(placeGps && placeGps.length === 2) ? {
          lat: Number(placeGps[0]),
          lng: Number(placeGps[1])
        } : undefined}
        callback={(success) => {
          if (success) {
            if (!isAlreadyOpened) replace(`/firstopening/${id}`)
            else {
              goBack()
              action()
            }
          } else {
            goBack()
          }
        }}
      />}

      <div className='menu__buttons --top'>
        <CircleBtn
          Icon={Compass}
          text={t('navigate')}
          action={() => {
            window.open(`https://www.google.com/maps/search/?api=1&query=${placeAddress}`)
          }}
        />

        <div className='buttons__col center'>
          <div style={disabled ? { opacity: 0.5 } : undefined}>
            <BigCircleBtn
              text={doorState?.door === 'opened'
                ? t('doorOpen')
                : doorState?.lock === 'unlocked'
                  ? t('pullTheDoor')
                  : t('open')}
              status={doorState?.door === 'opened'
                ? STATUS.succeed
                : doorState?.lock === 'unlocked'
                  ? STATUS.pending
                  : STATUS.idle}
              action={() => {
                if (disabled) return
                if (config?.warehouseLocationCheckEnabled) openPopup('checkingMagLocation')
                else if (!isAlreadyOpened) push(`/firstopening/${id}`)
                else action()
              }} />
          </div>

          {!expanded && <CircleBtn
            text={t('manage')}
            Icon={Arrow}
            action={toggleMenu} />}
        </div>

        <CircleBtn
          disabled={!(gateHasOnlineAccess && hasPermissionsToOpen) || inFuture}
          text={t('openTheGate')}
          Icon={Gate}
          action={() => {
            push(`/warehouses/${id}/gate?from=mag`)
          }} />
      </div>
    </>
  )
}

export default MagActions